export default function sortArticles(articles) {
	// Sort articles by:
	// 1. Serie number (if applicable)
	// 2. Type (alphabetically)
	// 3. Name (alphabetically, with numeric sorting)

	if (!articles) {
		return articles;
	}

	return [...articles].sort(
		(a, b) =>
			(a.serieNumber || 0) - (b.serieNumber || 0) ||
			a.type.localeCompare(b.type) ||
			a.name.localeCompare(b.name, undefined, { numeric: true }),
	);
}
